module.exports = __webpack_public_path__ + "img/sport2.16060b29.png";